import React, { useEffect, useState } from "react";
import * as API from "src/api/high_risk";
import List from "src/pages/high_risk/register/list";
import Header from "src/pages/high_risk/register/header";
import { Spin, Modal, InputNumber, Input, Select, Space } from "antd";
import { FilterMatchMode } from "primereact/api";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import MODAL from "src/pages/high_risk/list/modal_execute";

import moment from "moment";
import { useUserContext } from "src/contexts/userContext";
import { useHighRiskContext } from "src/contexts/high_risk/highriskContext";
import _ from "lodash";
import { SearchInput } from "src/components/filters";

const RegisterList = () => {
  const { user, message, checkRole } = useUserContext();
  const { state, dispatch } = useHighRiskContext();

  const [search, setSearch] = useState({
    global: { value: "", matchMode: FilterMatchMode.CONTAINS },
  });

  const [loading, setLoading] = useState(false);

  const [first, set_first] = useState(0);
  const [per_page, set_per_page] = useState(50);

  const [list, setList] = useState();
  const [group_list, setgroup_list] = useState([]);
  const [type, setType] = useState();

  const [factcount, setFactcount] = useState(0);

  useEffect(() => {
    state.department &&
      API.getRegister({
        year: moment(state.end_date).format("YYYY"),
        dep_code: state.department,
      })
        .then((res) => {
          setList(_.filter(res, (a) => a.approve_id === 41));
        })
        .catch((error) => {
          message({
            type: "error",
            error,
            title: "Эрсдлийн үнэлгээний татахад алдаа гарлаа",
          });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.refresh, state.department, state.end_date]);

  return (
    <div className=" card flex  p-2 border rounded text-xs">
      {" "}
      <Modal
        style={{ width: "600" }}
        width={800}
        height={550}
        open={state.list.modal}
        onCancel={() =>
          dispatch({
            type: "STATE",
            data: { list: { ...state.list, modal: false } },
          })
        }
        title={"Эрсдлийг бууруулах"}
        closeIcon={<div className="">x</div>}
        footer={false}
      >
        <MODAL />
      </Modal>
      <DataTable
        size="small"
        value={list}
        dataKey="id"
        filters={search}
        paginator
        scrollable
        removableSort
        rowHover
        showGridlines
        className="table-xs"
        filterDisplay="menu"
        responsiveLayout="scroll"
        sortMode="multiple"
        rowGroupMode="subheader"
        groupRowsBy="typename"
        scrollHeight={window.innerHeight - 360}
        globalFilterFields={["tn", "short_name", "position_namemn"]}
        emptyMessage={
          <div className="text-xs text-orange-500 italic font-semibold">
            Мэдээлэл олдсонгүй...
          </div>
        }
        header={
          <div className="flex items-center justify-between border-b pb-2 mb-2  text-xs">
            <SearchInput
              className="md:w-80"
              placeholder="Хайх..."
              value={search.global.value}
              onChange={(v) => {
                // ⚠ global.value-г ШУУД өөрчилдөг байв. { ...search } нь
                //   гүехэн хуулбар тул `global` нь эх объектоо заасаар
                //   байдаг — өөрөөр хэлбэл React төлөв мутацилагдана.
                setSearch({ ...search, global: { ...search.global, value: v } });
                dispatch({ type: "STATE", data: { tn: null } });
              }}
            />
          </div>
        }
        rowGroupHeaderTemplate={(data) => {
          return (
            <div className="text-xs font-semibold">
              <span> {data.typename}</span>
            </div>
          );
        }}
        // rowClassName={(data) => {
        //   var result = "cursor-pointer";
        //   if (state.id === data.id) result = " bg-blue-500 text-white";
        //   return result;
        // }}
        // onRowClick={(e) => {
        //   dispatch({ type: "STATE", data: { id: e.data.id } });
        // }}
        rows={per_page}
        first={first}
        onPage={(event) => {
          set_first(event.first);
          set_per_page(event.rows);
        }}
        paginatorTemplate={{
          layout:
            "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
          RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
              { label: 50, value: 50 },
              { label: 100, value: 100 },
              { label: 200, value: 200 },
              { label: 500, value: 500 },
            ];
            return (
              <>
                <span
                  className="text-xs mx-1"
                  style={{
                    color: "var(--text-color)",
                    userSelect: "none",
                  }}
                >
                  <span className="font-semibold">Нэг хуудсанд:</span>
                </span>
                <Select
                  size="small"
                  showSearch={false}
                  value={options.value}
                  onChange={(value) => {
                    options.onChange({
                      value: value,
                    });
                  }}
                >
                  {_.map(dropdownOptions, (item) => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.value}
                    </Select.Option>
                  ))}
                </Select>
              </>
            );
          },
          CurrentPageReport: (options) => {
            return (
              <span
                style={{
                  color: "var(--text-color)",
                  userSelect: "none",
                  width: "200px",
                  textAlign: "center",
                }}
              >
                <span className="text-xs font-semibold">
                  <span>
                    {options.first} - {options.last}
                  </span>
                  <span className="ml-3">Нийт: {options.totalRecords}</span>
                </span>
              </span>
            );
          },
        }}
        paginatorClassName="justify-content-end"
      >
        <Column
          align="center"
          className="text-xs"
          style={{ minWidth: "40px", maxWidth: "40px" }}
          body={(data, row) => row.rowIndex + 1}
        />

        <Column
          header="Хэсгийн нэр"
          field="department_name"
          className="text-xs"
          style={{ minWidth: "200px", maxWidth: "200px" }}
        />
        <Column
          header="Хийж гүйцэтгэх ажил"
          field="jobdesc"
          className="text-xs"
        />
        <Column
          header="Эрсдлийн эрэмбэ"
          field="jobdesc"
          align="center"
          className="text-xs"
          style={{ minWidth: "80px", maxWidth: "80px" }}
          body={(data) => {
            return data.matrix[0].grade;
          }}
        />
        <Column
          header="Эрсдлийн түвшин"
          align="center"
          field="jobdesc"
          className="text-xs"
          style={{ minWidth: "80px", maxWidth: "80px" }}
          body={(data) => {
            return data.matrix[0].score;
          }}
        />
        <Column
          header="Эрсдлийн бууруулах арга хэмжээний санал"
          align="center"
          field="jobdesc"
          className="text-xs"
          body={(data) => {
            var result = _.orderBy(data.execution, ["id"], ["desc"]);
            return result[0]?.comment;
          }}
        />
        <Column
          header="Саналын дагуу хийж гүйцэтгэсэн ажил"
          align="center"
          field="jobdesc"
          className="text-xs"
          body={(data) => {
            var result = _.orderBy(data.execution, ["id"], ["desc"]);
            return result[0]?.execution;
          }}
        />
        <Column
          header="Баталгаажуулалт"
          field="status_percent"
          align="center"
          className="text-xs"
          style={{ minWidth: "150px", maxWidth: "150px" }}
          body={(data, row) => {
            return (
              <>
                {data.approve_id === null ? (
                  <button
                    title="Баталгаажуулах"
                    className="p-1 flex items-center justify-center font-semibold text-green-500 rounded-full border-2 border-green-500 hover:bg-green-500 hover:scale-125 hover:text-white focus:outline-none duration-300"
                    onClick={() => {
                      dispatch({
                        type: "STATE",
                        data: {
                          register: {
                            ...state.approve,
                            id: data.id,
                            modal_approve: true,
                          },
                        },
                      });
                    }}
                  >
                    <i className="fe fe-file" />
                  </button>
                ) : data.approve_id && data.approve_id === 41 ? (
                  <>
                    <i className="fe fe-check-circle text-xl text-green-600 pr-1" />{" "}
                    {data.approve_name}
                  </>
                ) : (
                  <>
                    <i className="fe fe-minus text-red-600 rounded-full border-3 border-red-600" />{" "}
                    {data.approve_name}
                  </>
                )}
              </>
            );
          }}
        />
        <Column
          align="center"
          header=""
          className="text-xs"
          style={{ minWidth: "70px", maxWidth: "70px" }}
          headerClassName="flex items-center justify-center"
          body={(item) => {
            return (
              <div className="flex items-center justify-center gap-2">
                <button
                  className="p-1 flex items-center justify-center font-semibold text-green-600 rounded-full border-2 border-green-600 hover:bg-green-500 hover:scale-125 hover:text-white focus:outline-none duration-300"
                  onClick={() => {
                    dispatch({
                      type: "STATE",
                      data: {
                        list: { ...state.list, modal: true, job_id: item.id },
                      },
                    });
                  }}
                >
                  <i className="fe fe-chevrons-right" />
                </button>
              </div>
            );
          }}
        />
      </DataTable>
    </div>
  );
};

export default React.memo(RegisterList);
